import { Paper, type PaperProps } from '../../primitives/Paper'

export type AccordionGroupProps = PaperProps

/**
 * AccordionGroup
 *
 * Demos:
 * - [AccordionGroup](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-accordion--docs)
 *
 */
export const AccordionGroup = (rest: AccordionGroupProps) => <Paper {...rest} />
